const placements = {
  // nl

  nos: {
    title: 'nos',
    height: 65,
    lang: 'nl',
  },
  vice: {
    title: 'vice',
    height: 85,
    lang: 'nl',
  },
  nrc: {
    title: 'nrc',
    height: 47,
    lang: 'nl',
  },
  fd: {
    title: 'fd',
    height: 62,
    bg: '#f1ded3',
    lang: 'nl',
  },
  telegraaf: {
    title: 'telegraaf',
    height: 58,
    lang: 'nl',
  },

  // de

  // derspiegel: {
  //   title: 'derspiegel',
  //   height: 48,
  //   lang: 'de',
  // },

  // fa: {
  //   title: 'fa',
  //   height: 117,
  //   lang: 'de',
  // },

  // zeit: {
  //   title: 'zeit',
  //   height: 50,
  //   lang: 'de',
  // },

  // stern: {
  //   title: 'stern',
  //   height: 129,
  //   bg: '#f9f9f9',
  //   lang: 'de',
  // },

  // regionaal
  nhnieuws: {
    title: 'nhnieuws',
    height: 64,
    bg: '#f4f4f4',
    lang: 'regionaal',
  },
  at5: {
    title: 'at5',
    height: 64,
    bg: '#f4f4f4',
    lang: 'regionaal',
  },
  '1limburg': {
    title: '1limburg',
    height: 58,
    bg: '#fff',
    lang: 'regionaal',
  },
  omroepzeeland: {
    title: 'omroepzeeland',
    height: 56,
    bg: '#fff',
    lang: 'regionaal',
  },
  omroepbrabant: {
    title: 'omroepbrabant',
    height: 80,
    bg: '#fff',
    lang: 'regionaal',
  },
  rijnmond: {
    title: 'rijnmond',
    height: 56,
    bg: '#fff',
    lang: 'regionaal',
  },
  omroepwest: {
    title: 'omroepwest',
    height: 56,
    bg: '#fff',
    lang: 'regionaal',
  },
  rtvutrecht: {
    title: 'rtvutrecht',
    height: 48,
    bg: '#fff',
    lang: 'regionaal',
  },
  omroepgelderland: {
    title: 'omroepgelderland',
    height: 56,
    bg: '#fff',
    lang: 'regionaal',
  },
  omroepflevoland: {
    title: 'omroepflevoland',
    height: 44,
    bg: '#fff',
    lang: 'regionaal',
  },
  rtvnoord: {
    title: 'rtvnoord',
    height: 88,
    bg: '#fff',
    lang: 'regionaal',
  },
  omropfryslan: {
    title: 'omropfryslan',
    height: 94,
    bg: '#fff',
    lang: 'regionaal',
  },
  dvhn: {
    title: 'dvhn',
    height: 121,
    bg: '#fff',
    lang: 'noorden',
  },
  lc: {
    title: 'lc',
    height: 107,
    bg: '#fff',
    lang: 'noorden',
  },
  sikkom: {
    title: 'sikkom',
    height: 40,
    bg: '#f5f5f5',
    lang: 'noorden',
  },
};

export default function getPlacement(placement = null, lang = null) {
  if (placement == 'regionaal') {
    placement = null;
    lang = 'regionaal';
  }
  if (placement == 'noorden') {
    placement = null;
    lang = 'noorden';
  }
  if (placement) return placements[placement];
  if (!placement && lang) {
    let pl = Object.values(placements).filter((o) => o.lang == lang);
    return pl[Math.floor(Math.random() * pl.length)];
  }

  if (!placement && !lang) {
    return Object.values(placements)[
      Math.floor(Math.random() * Object.values(placements).length)
    ];
  }
}
